import React from "react";
import { ReactComponent as AccountSVG } from "../static/icons/account.svg";
import { Link, useNavigate } from "react-router-dom"
import { useSelector } from "react-redux";
import menu from "../static/icons/menu.png"

function NavbarMobile() {
    const signedIn = useSelector(state => state.user.signedIn)
    const navigate = useNavigate();
    const [open, setOpen] = React.useState(false);

    const toggleNav = () => {
        console.log(open)
        setOpen(!open);
    }

    return (
        <nav className="desktop-hidden bg-white shadow">
            <div className="flex items-center p-2 relative text-center justify-between">
                <img src={menu} alt="menu" className="mr-auto" onClick={toggleNav} />
                <p className="navbar-logo font-bold mx-auto text-lg flex-1">Surf Journal</p>
                {signedIn ? <div onClick={() => navigate("/app/account")}><AccountSVG className="nav-icon ml-auto"/></div> : <div><Link to="/login" className="ml-auto">Login</Link></div>}
            </div>

            <div className={`${open ? "sidebar flex flex-col items-center justify-around bg-white w-6/12 shadow-lg rounded" : "hidden"}`}>
                <Link to="/" className="navlink mx-4">Home</Link>
                {signedIn && <Link to="/app/breaks" className="navlink mx-4" onClick={toggleNav}>Breaks</Link>}
                {/* {signedIn && <Link to="/app/map" className="navlink mx-4" onClick={toggleNav}>Map</Link>}
                {signedIn && <Link to="/app/buoys" className="navlink mx-4" onClick={toggleNav}>Buoys</Link>} */}
                <Link to="/about" className="navlink mx-4" onClick={toggleNav}>About</Link>
            </div>
        </nav>
    );
}

export default NavbarMobile;